import React from "react"

import {Wrapper} from "./components"
import Modal from "../../../../components/Modal"
import connect from "./connect"

export type ModalProps = {
    open: boolean
    closeText: string
    handleClose: () => void
    children: JSX.Element
    mobileHeight: number
    desktopHeight: number
}

export const SimpleModal = ({open, handleClose, children, closeText, mobileHeight, desktopHeight}: ModalProps) => {
    return (
        <Wrapper mobileHeight={mobileHeight} desktopHeight={desktopHeight}>
            <Modal open={open} handleClose={handleClose} hideBackdrop>
                <>
                    {children}
                    {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role */}
                    <div tabIndex={0} role="button" onFocus={handleClose} aria-label={closeText} />
                </>
            </Modal>
        </Wrapper>
    )
}

export default connect(SimpleModal)
